module.exports = __webpack_public_path__ + "static/media/CarbonoactivoBGP.be9e646a.pdf";